import {
  TablePagination as MuiTablePagination,
  TablePaginationProps as MuiTablePaginationProps,
} from '@mui/material';

export type TablePaginationProps = MuiTablePaginationProps;

export const TablePagination = MuiTablePagination;
